import { createTheme as muiCreateTheme } from '@mui/material';

import { createBreakpoints } from './breakpoints';
import { createColor } from './color';
import componentsTheme from './components';
import { createElevation } from './elevation';
import { createMixins } from './mixins';
import { createShadows } from './shadows';
import { createTypography } from './typography';
import { createZIndex } from './zIndex';

import type { ThemeMode } from '../foundation';

const createTheme = (themeMode: ThemeMode) => {
  let theme = muiCreateTheme({
    breakpoints: createBreakpoints(),
    color: createColor(themeMode),
    elevation: createElevation(themeMode),
    typography: createTypography(themeMode),
    shadows: createShadows(themeMode),
    zIndex: createZIndex(),
    components: {
      ...componentsTheme,
    },
  });

  theme = muiCreateTheme(theme, {
    mixins: createMixins({ theme }),
  });

  return theme;
};

export default createTheme;
